<div class="input-field">
  @if (isTaskPercentage == true) {
    <div class="divider"></div>
    <div class="frame-165">
        <div class="frame-64">
          <img class="clipboard-text" src="../../assets/clipboard-text.png" />
        </div>
      <div class="introduction">Task progress</div>
    </div>
  } @else {
    <div class="input-label">
      {{ label }}
    </div>
  }
  <div class="frame-157">

    <div class="slider-wrapper">
      @if (isTaskPercentage == false) {
        <div class="don-t-know"><b>Don't know</b></div>
      }
      <div class="slider-bar" #bar (click)="onBarClick($event)">
        <div 
          class="slider-fill"
          [style.width.%]="value"
        ></div>
        <div
          class="slider-thumb"
          [style.left.%]="value"
          (mousedown)="onThumbMouseDown($event)"
          tabindex="0"
        ></div>
      </div>
      <div class="_100"><b>100%</b></div>
      <div class="slider-value"><b>{{ value | number : '1.0-0' }}%</b></div>
    </div>
  </div>
</div>
